module.exports = __webpack_public_path__ + "img/melvid-resumo2.06ffd8ee.png";